export const formatDefault = 'DD.MM.YYYY'
export const formatFullMonth = 'DD MMM YYYY'
export const formatUTC = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
export const formatFull = 'DD MMM YYYY HH:mm'

const isProd = process.env.NODE_ENV === 'production'

export const baseURL = isProd
    ? process.env.VUE_APP_API_URL_PROD
    : process.env.VUE_APP_API_URL